import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { toast } from 'react-toastify';

import configureStore from './store/config';
import ChinaPressRouter from './router'
import AxiosInterceptors from 'utils/axios-interceptors'
// import 'utils/i18'

import './stylesheets/base.scss'
import 'react-bootstrap-typeahead/css/Typeahead.css';

const store = configureStore();
const persistor = persistStore( store );

toast.configure()

const App = () => {
  return (
    <Provider store={ store }>
      <PersistGate loading={ null } persistor={ persistor }>
        <HashRouter>
          <ChinaPressRouter/>
        </HashRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
